<template>
<div class="OrganIndex">
    <div class="warp">
        <div class="organ_top_box">
            <div v-if="hostInfoData.hostinfo.bannerlist.length && hostInfoData.hostinfo.bannerlist[0].bannerlogourl" class="bg_div"></div>
            <img class="bc_img" :src="(hostInfoData.hostinfo.bannerlist.length&&hostInfoData.hostinfo.bannerlist[0].bannerlogourl) ?hostInfoData.hostinfo.bannerlist[0].bannerlogourl :  require('@/common/images/organ/default_bg.png') " alt="">
            <div class="organ_info_box">
                <img :src="hostInfoData.hostinfo.hostlogourl" alt="">
                <div class="right_info_box">
                    <div class="organ_data_box">
                        <div>
                            <span>{{hostInfoData.hostinfo.hostname}}</span>
                            <img :src="require('@/common/images/organ/grrz.png')" alt="">
                        </div>
                        <div>
                            <p>课程数&nbsp;{{hostInfoData.hostinfo.coursecount}} <span>|</span>学生数&nbsp;{{hostInfoData.hostinfo.studentcount}}<span>|</span>好评度&nbsp;{{hostInfoData.hostinfo.commentrate}}%</p>
                            <p @click="focusOnHost(hostInfoData.isfavorite)"><img :src="hostInfoData.isfavorite === 0 ? require('@/common/images/organ/icon1.png') : require('@/common/images/organ/icon2.png')" alt="">{{hostInfoData.isfavorite === 0 ? '关注机构' : '取消关注'}}</p>
                        </div>
                    </div>
                    <div class="organ_tabs_box">
                        <div @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">主页</div>
                        <div @click="menuClick(2)" :class="menuIndex === 2 ? 'active' : ''">课程<span>{{hostInfoData.hostinfo.coursecount}}</span></div>
                        <div @click="menuClick(5)" :class="menuIndex === 5 ? 'active' : ''" v-show="hostInfoData.hostnewqbanklist.length>0">题库<span>{{hostInfoData.hostinfo.qbcount}}</span></div>
                        <div @click="menuClick(3)" :class="menuIndex === 3 ? 'active' : ''">老师<span>{{hostInfoData.hostinfo.teachercount}}</span></div>
                        <div @click="menuClick(4)" :class="menuIndex === 4 ? 'active' : ''">关于我们</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="organ_content_box">
            <div v-show="menuIndex === 1" class="organ_index">
                <p class="title_text">最新课程</p>
                <div v-if="hostInfoData.hostnewcourselist.length === 0" class="no_data_box">当前暂无最新课程</div>
                <div v-if="hostInfoData.hostnewcourselist.length > 0" class="course_item_box">
                    <div @click="courseClick(item.courseid)" class="course_item_div" v-for="(item, index) in hostInfoData.hostnewcourselist" :key="index">
                        <img v-lazy="item.coverurl" :alt="item.subject">
                        <div>
                            <p>{{item.subject}}</p>
                            <p class="flex-box">
                                <span>{{item.feettype === 1 ? '免费' : `￥${item.saleprice}`}}</span>
                                <!--{{item.joincount}}人参与-->
                                <span class="limit-box" v-if="item.islimitcount">限时折扣</span>
                            </p>
                        </div>
                    </div>
                </div>

                <p class="title_text" style="margin-top: 0px;">热门免费</p>
                <div v-if="hostInfoData.hostfreecourselist.length === 0" class="no_data_box">当前暂无免费课程</div>
                <div v-if="hostInfoData.hostfreecourselist.length > 0" class="course_item_box">
                    <div @click="courseClick(item.courseid)" class="course_item_div" v-for="(item, index) in hostInfoData.hostfreecourselist" :key="index">
                        <img v-lazy="item.coverurl" :alt="item.subject">
                        <div>
                            <p>{{item.subject}}</p>
                            <p class="flex-box">
                                <!--{{item.joincount}}人参与-->
                                <span class="limit-box" v-if="item.islimitcount">限时折扣</span>
                            </p>
                        </div>
                    </div>
                </div>

                <p class="title_text" style="margin-top: 0px;">明星老师</p>
                <div v-if="hostInfoData.hostteacherlist.length === 0" class="no_data_box">当前暂无明星老师</div>
                <div v-if="hostInfoData.hostteacherlist.length > 0" class="teachers_div">
                    <div @click="toTeacherIndex(item)" v-for="(item, index) in hostInfoData.hostteacherlist" :key="index" class="teacher_item_box">
                        <img class="teacher_img" :src="item.teacherlogourl" alt="">
                        <div class="teacher_info">
                            <p>{{item.teachername}}</p>
                            <p>课程 {{item.coursecount}} ｜学生 {{item.studentcount}}</p>
                            <!-- <p>马士兵老师，1994-1999 年就读于清华大学，历任程序员、Team Leader、Project Manager马士兵老师，1994-1999 年就读于清华大学，历任程序员、Team Leader、Project Manager</p> -->
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div v-show="menuIndex === 2" class="course_box">
                <p class="title_text">全部课程</p>
                <div v-if="this.allCourseData.length === 0" class="no_data_img_box">
                    <img class="no_data_img" :src="require('@/common/images/organ/no_data.png')" alt="">
                    <span>当前暂无课程</span>
                </div>
                <div v-if="this.allCourseData.length > 0" class="course_item_box">
                    <div @click="courseClick(item.courseid)" class="course_item_div" v-for="(item, index) in allCourseData" :key="index">
                        <img v-lazy="item.coverurl" :alt="item.subject">
                        <div>
                            <p>{{item.subject}}</p>
                            <p class="flex-box">
                                <span>{{item.feettype === 1 ? '免费' : `￥${item.saleprice}`}}</span>
                                <!--{{item.joincount}}人参与-->
                                <span class="limit-box" v-if="item.islimitcount">限时折扣</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="this.allCourseData.length > 0" class="page_box">
                    <el-pagination background layout="prev, pager, next" :page-size="25" :total="courseTotalPage"  @current-change="cfPage"></el-pagination>
                </div>
            </div>


            <div v-show="menuIndex === 3" class="teacher_box">
                <p class="title_text">全部老师</p>
                <div v-if="this.allTeachersData.length === 0" class="no_data_img_box">
                    <img class="no_data_img" :src="require('@/common/images/organ/no_data.png')" alt="">
                    <span>当前暂无老师</span>
                </div>
                <div v-if="this.allTeachersData.length > 0" class="teachers_div">
                    <div @click="toTeacherIndex(item)" v-for="(item, index) in allTeachersData" :key="index" class="teacher_item_box">
                        <img class="teacher_img" :src="item.teacherlogourl" alt="">
                        <div class="teacher_info">
                            <p>{{item.teachername}}</p>
                            <p>课程 {{item.coursecount}} ｜学生 {{item.studentcount}}</p>
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="this.allTeachersData.length > 0" class="page_box" style="margin-top: 12px;">
                    <el-pagination background layout="prev, pager, next" :page-size="12" :total="teacherTotalPage"  @current-change="tfPage"></el-pagination>
                </div>
            </div>


            <div v-show="menuIndex === 5 && this.allQuestData.length>0" class="course_box">
                <p class="title_text">全部题库</p>
                <div v-if="this.allQuestData.length === 0" class="no_data_img_box">
                    <img class="no_data_img" :src="require('@/common/images/organ/no_data.png')" alt="">
                    <span>当前暂无题库</span>
                </div>
                <div v-if="this.allQuestData.length > 0" class="course_item_box">
                    <div @click="questClick(item.bankid)" class="course_item_div" v-for="(item, index) in allQuestData" :key="index">
                        <img v-lazy="item.coverurl" :alt="item.subject">
                        <div>
                            <p>{{item.subject}}</p>
                            <p class="flex-box">
                                <span>{{item.feettype === 1 ? '免费' : `￥${item.saleprice}`}}</span>
                                <!--{{item.joincount}}人参与-->
                                <span class="limit-box" v-if="item.islimitcount">限时折扣</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="this.allQuestData.length > 0" class="page_box">
                    <el-pagination background layout="prev, pager, next" :page-size="25" :total="questTotalPage"  @current-change="questPage"></el-pagination>
                </div>
            </div>


            <div v-show="menuIndex === 4" class="aboutus_box">
                <div class="no_description_box" v-if="hostInfoData.withinfo.withwe === ''">
                    <img :src="require('@/common/images/other/no_data.png')" alt="">
                    <span>当前暂无简介</span>
                </div>
                <div class="description_box" v-else v-html="hostInfoData.withinfo.withwe"></div>
                <!-- <img class="about_img" :src="hostInfoData.withinfo.bannerlogourl === ''? require('@/common/images/organ/default_bg.png') : hostInfoData.withinfo.bannerlogourl" alt="">
                <h5>机构简介</h5> -->
                <!-- <p>{{hostInfoData.withinfo.description}}</p> -->
                <!-- <p v-html="hostInfoData.withinfo.description"></p>
                <h5>联系方式</h5>
                <div>
                    <p>座机：{{hostInfoData.withinfo.linktel}}</p>
                    <p>手机：{{hostInfoData.withinfo.linktel}}</p>
                    <p>邮箱：{{hostInfoData.withinfo.linkemail}}</p>
                </div> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getCourseHostDetailInfo, getAllCourseByHost, getAllTeacherByHost, uploadCourseHostFollow} from 'api/api'
import {getAllQuestionbankByHost} from 'api/questionbank'
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'OrganIndex',
    data() {
        return {
            menuIndex: 1, // 机构导航： 1、主页  2、课程  3、老师  4、关于我们
            hostInfoData: {
                hostinfo: {
                    bannerlist: [
                        {
                            bannerlogourl: ''
                        }
                    ]
                },
                isfavorite: 0,
                hostnewcourselist: [],
                hostnewqbanklist: [],
                hostfreecourselist: [],
                hostteacherlist: [],
                withinfo: {}
            },
            allCourseData: [],
            courseTotalPage: 0,
            teacherTotalPage: 0,
            allTeachersData: [],
            allQuestData: [],
            questTotalPage: 0,
        }
    },
    mounted() {
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MAgencyView',
                query: {
                    hostid: this.$route.query.hostid,
                    chid: this.$route.query.chid ? this.$route.query.chid : ''
                }
            })
        }
        this.findCourseHostDetailInfo()
        if(this.$route.query.tabs) {
            // console.log('this.$route.query.tabs:',parseInt(this.$route.query.tabs))
            this.menuIndex = parseInt(this.$route.query.tabs)
            this.findAllCourseByHost(1)
            this.findAllQuestBank(1)
        }
    },
    methods: {
        // 导航点击
        menuClick(val) {
           this.menuIndex = val
            if (val === 2 && this.allCourseData.length === 0) {
                this.findAllCourseByHost(1)
            }
            if (val === 3 && this.allTeachersData.length === 0) {
                this.findAllTeacherByHost(1)
            }
            if (val === 5 && this.allQuestData.length === 0) {
                this.findAllQuestBank(1)
            }
        },
        // 关注机构--取消关注
        focusOnHost(val) {
            // console.log(val)
            this.setLoading(true)
            var params = {
                hostid: this.$route.query.hostid,
                // hostid: '1100023',
                optype: val === 0 ? 1 : 2
            }
            uploadCourseHostFollow({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    if (data.code) {
                        if (val === 1) {
                            this.$message.success('已取消关注')
                            this.hostInfoData.isfavorite = 0
                        } else {
                            this.$message.success('关注成功')
                            this.hostInfoData.isfavorite = 1
                        }
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            
        },
        // 获取机构详情信息
        findCourseHostDetailInfo() {
            this.setLoading(true)
            var params = {
                hostid: this.$route.query.hostid
                // hostid: '1100023'
            }
            getCourseHostDetailInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.hostInfoData = data.data
                    
                    // console.log(this.hostInfoData)
                    // this.tableData = data.data.content
                    // this.total = data.data.pageinfo.rowCount
                    document.title=this.hostInfoData.hostinfo.hostname
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取全部课程
        findAllCourseByHost(val) {
            this.setLoading(true)
            var params = {
                hostid: this.$route.query.hostid,
                // hostid: '1100023',
                page: val,
                pagesize: 25
            }
            getAllCourseByHost({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.allCourseData = data.data.courselist
                    this.courseTotalPage = data.data.pageinfo.rowCount
                    
                    // console.log(data.data)
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 课程点击
        courseClick(id) {
            // console.log('课程id：', id)
            this.$router.push({name: 'CourseDetails', query: {'cid': id, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        // 课程分页
        cfPage(){
            let clickPage = $(".el-pagination .active").html()
            // this.$message.success(`第${clickPage}页`)
            this.findAllCourseByHost(clickPage)
        },
        // 获取全部老师
        findAllTeacherByHost(val) {
            this.setLoading(true)
            var params = {
                hostid: this.$route.query.hostid,
                // hostid: '1100023',
                page: val,
                pagesize: 12
            }
            getAllTeacherByHost({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.allTeachersData = data.data.teacherlist
                    this.teacherTotalPage = data.data.pageinfo.rowCount
                    
                    // console.log(data.data)
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 全部老师分页
        tfPage(){
            let clickPage = $(".el-pagination .active").html()
            // this.$message.success(`第${clickPage}页`)
            this.findAllTeacherByHost(clickPage)
            
        },
        // 点击老师
        toTeacherIndex(val) {
            console.log(val)
            // this.$router.push({name: name, query: {'eventinnerid': eventinnerid, 'title': title}})
            this.$router.push({name: 'TeacherIndex', query: {'tid': val.teacherid}})
        },
        // 获取全部题库
        findAllQuestBank(val){
            this.setLoading(true)
            let params = {
                hostid: this.$route.query.hostid,
                page: val,
                pagesize: 25
            };
            getAllQuestionbankByHost({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.allQuestData = data.data.quesbanklist
                    this.questTotalPage = data.data.pageinfo.rowCount
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 题库分页
        questPage(){
            let clickPage = $(".el-pagination .active").html();
            // this.$message.success(`第${clickPage}页`)
            this.findAllQuestBank(clickPage)
        },
        //点击题库
        questClick(id){
            this.$router.push({name: 'QuestionDetails', query: {'qid': id}})
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(
            ['loginPop', 'user', 'domainInfo']
        )
    },
    components: {
        // StandardCourseCard
    }
}
</script>

<style lang="scss" type="text/scss">
.OrganIndex {
    // margin-top: 80px;
    .warp {
        font-family:PingFangSC-Medium,PingFang SC;
        color: #333;
        width: 1200px;
        margin: 0 auto;
        .organ_top_box {
            position: relative;
            height: 290px;
            padding-top: 5px;
            // background-color: pink;
            box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
            .bc_img {
                width: 100%;
                height: 240px;
            }
            .bg_div {
                width: 100%;
                height: 240px;
                background-color: rgba(0, 0, 0, .3);
                position: absolute;
                top: 5px;
            }
            .organ_info_box {
                box-sizing: border-box;
                padding: 0 30px;
                display: flex;
                width: 100%;
                position: absolute;
                bottom: 0;
                &>img {
                    width: 150px;
                    height: 150px;
                    margin-right: 20px;
                }
                .right_info_box {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .organ_data_box {
                        color: #FFF;
                        &>div:nth-of-type(1){
                            height: 40px;
                            display: flex;
                            align-items: center;
                            &>span {
                                font-size:28px;
                                margin-right: 10px;
                            }
                            &>img {
                                width: 75px;
                                height: 25px;
                            }
                        }
                        &>div:nth-of-type(2){
                            display: flex;
                            align-items: baseline;
                            justify-content: space-between;
                            &>p:nth-of-type(1){
                                font-size: 14px;
                                // color: red;
                                span{
                                    margin: 0 15px;
                                    font-size: 14px;
                                }
                            }
                            &>p:nth-of-type(2){
                                -moz-user-select:none; /* Firefox私有属性 */
                                -webkit-user-select:none; /* WebKit内核私有属性 */
                                -ms-user-select:none; /* IE私有属性(IE10及以后) */
                                -khtml-user-select:none; /* KHTML内核私有属性 */
                                -o-user-select:none; /* Opera私有属性 */
                                user-select:none; /* CSS3属性 */
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 118px;
                                height: 36px;
                                border-radius:4px;
                                border: 1px solid #FFF;
                                font-size:14px;
                                img{
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 10px;
                                }
                            }
                            &>p:nth-of-type(2):active{
                                background-color: rgba(255, 255, 255, 0.1);
                            }
                        }
                    }
                    .organ_tabs_box {
                        background-color: rgb(255, 255, 255);
                        // padding-left: 48px;
                        height: 50px;
                        display: flex;
                        align-items: center;
                        &>div{
                            -moz-user-select:none; /* Firefox私有属性 */
                            -webkit-user-select:none; /* WebKit内核私有属性 */
                            -ms-user-select:none; /* IE私有属性(IE10及以后) */
                            -khtml-user-select:none; /* KHTML内核私有属性 */
                            -o-user-select:none; /* Opera私有属性 */
                            user-select:none; /* CSS3属性 */
                            box-sizing: border-box;
                            cursor: pointer;
                            font-size:16px;
                            padding: 0 10px;
                            height: 50px;
                            line-height: 50px;
                            // display: flex;
                            // align-items: center;
                            margin: 0 40px;
                            color: #333;
                            // font-weight: bold;
                            position: relative;
                            &>span {
                                font-size:10px;
                                color: #999;
                                line-height:14px;
                                position: absolute;
                                top: 11px;
                                left: 43px;
                            }
                        }
                        &>div:hover{
                            color: #409EFFFF;
                        }
                        .active {
                            border-bottom: 2px solid #409EFFFF;
                            color: #409EFFFF;
                        }
                    }
                }
            }
        }
        .organ_content_box {
            padding: 0 10px;
            margin-bottom: 30px;
            &>div{
                .title_text {
                    font-size:18px;
                    line-height:25px;
                    margin: 30px 0;
                }
                .no_data_box {
                    padding: 60px 0;
                    padding-top: 30px;
                    color: #999;
                    line-height:20px;
                    text-align: center;
                }
                .no_data_img_box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding-top: 12px;
                    padding-bottom: 40px;
                    .no_data_img {
                        width: 128px;
                        height: 97px;
                        margin-bottom: 20px;
                    }
                    &>span {
                        color: #999;
                        line-height:20px;
                    }
                }
                .course_item_box {
                    display: flex;
                    flex-wrap: wrap;
                    .course_item_div {
                        margin-right: 12px;
                        margin-bottom: 20px;
                        cursor: pointer;
                        width: 226px;
                        border-radius:4px;
                        display: flex;
                        flex-direction: column;
                        &>img{
                            width: 226px;
                            height: 128px;
                            border-radius:4px;
                            margin-bottom: 10px;
                        }
                        &>div{
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            &>p {
                                text-align: justify;
                                padding: 0 4px;
                                line-height:20px;
                                // font-weight: bold;
                                font-size:16px;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            &>p:nth-of-type(2) {
                                padding: 10px 4px;
                                font-weight: normal;
                                color: #999;
                                font-size:12px;
                                &>span {
                                    font-size:14px;
                                    color: #FF4747FF;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                    .course_item_div:nth-of-type(5n){
                        margin-right: 0;
                    }
                    .course_item_div:hover{
                        transition: all .3s;
                        -moz-transition: all .3s;
                        -o-transition: all .3s;
                        -ms-transition: all .3s;
                        -webkit-transition: all .3s;
                        box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    }
                }
                .teachers_div {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .teacher_item_box {
                        box-sizing: border-box;
                        cursor: pointer;
                        border-radius:4px;
                        padding: 20px;
                        display: flex;
                        width: 50%;
                        margin-bottom: 8px;
                        .teacher_img {
                            width: 116px;
                            min-width: 116px;
                            height: 116px;
                            border-radius: 50%;
                            margin-right: 24px;
                        }
                        .teacher_info {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            &>p {
                                line-height:20px;
                                font-size:14px;
                            }
                            &>p:nth-of-type(1){
                                font-size:18px;
                                line-height:25px;
                                color: #333;
                            }
                            &>p:nth-of-type(2){
                                color: #999;
                                margin: 8px 0;
                            }
                            &>p:nth-of-type(3){
                                color: #666;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                    .teacher_item_box:hover {
                        box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    }
                }
                .page_box {
                    display: flex;
                    justify-content: center;
                }
            }
            // .organ_index {}
            // .course_box {}
            // .teacher_box {}
            .aboutus_box {
                display: flex;
                flex-direction: column;
                align-items: center;
                .no_description_box {
                    padding-top: 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    &>img {
                        margin-bottom: 30px;
                        width: 208px;
                    }
                    &>span {
                        color: #999;
                        font-size: 14px;
                    }
                }
                .description_box {
                    margin-top: 40px;
                    line-height: 28px;
                    font-size: 14px;
                    * {
                        text-align: justify;
                    }
                    img {
                        max-width: 100%!important;
                    }
                }
            }
        }
    }
    .flex-box{
        display: flex !important;
        align-items: center;
        .limit-box{
            width: 64px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid #FF4747;
            color: #FF4747;
            font-size: 12px !important;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
        }
    }
}
</style>